import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	request__attributes__dict: 'mw/request/attributes/dict',
	request__presets: 'mw/request/presets',
	request__filter: 'mw/request/filter',
	request__filter__apply: 'mw/request/filter/apply',
	request__preset__apply: 'mw/request/preset/apply',
	request__filter__apply__csvOneStep: 'mw/request/filter/apply/csvOneStep',
	request__filter__apply__csvexport: 'mw/request/filter/apply/csvexport',
	request__filter__apply__xlsxexport: 'mw/request/filter/apply/xlsxexport',
	request__attributes: 'mw/request/attributes',
	request__attributes__tree: 'mw/request/attributes/tree',
	request__preset__save: 'mw/request/preset/save',
	request__preset__info: 'mw/request/preset/info',
	request__filter__delete: 'mw/request/filter/delete',
	request__document__make: 'mw/request/document/make',
	request__document__getDocument: 'mw/request/document/getDocument',
	request__attributesExtended: 'mw/request/attributesExtended',
	request__filterExtended__apply: 'mw/request/filterExtended/apply',
	request__filterExtended__diagramm__sourceList: 'mw/request/filterExtended/diagramm/source-list',
};

export const requestApi = createApi({
	reducerPath: 'mw/requestApi',

	endpoints: (builder) => ({
		requestAttributesDict: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/request/attributes/dict',
				body,
				jsonType: true,
			}),
			providesTags: [tags.request__attributes__dict],
		}),
		requestPresets: builder.query({
			query: (body) => ({
				method: 'GET',
				url: `/mw/request/presets?${qs.stringify(body)}`,
			}),
			providesTags: [tags.request__presets],
		}),
		requestFilter: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/request/filter?${qs.stringify(body)}`,
			}),
			providesTags: [tags.request__filter],
		}),
		requestFilterApply: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/request/filter/apply',
				body,
			}),
			providesTags: [tags.request__filter__apply],
		}),
		requestPresetApply: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/request/preset/apply',
				body,
			}),
			providesTags: [tags.request__preset__apply],
		}),
		requestFilterApplyCsvOneStep: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/request/filter/apply/csvOneStep',
				body,
				jsonType: true,
			}),
			providesTags: [tags.request__filter__apply__csvOneStep],
		}),
		requestFilterApplyCsvexport: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/request/filter/apply/csvexport',
				body,
				jsonType: true,
			}),
			providesTags: [tags.request__filter__apply__csvexport],
		}),
		requestFilterApplyXlsxexport: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/request/filter/apply/xlsxexport',
				body,
				jsonType: true,
			}),
			providesTags: [tags.request__filter__apply__xlsxexport],
		}),
		requestAttributes: builder.query({
			query: (body) => ({
				method: 'GET',
				url: `/mw/request/attributes?${qs.stringify(body)}`,
			}),
			providesTags: [tags.request__attributes],
		}),
		requestAttributesTree: builder.query({
			query: (body) => ({
				method: 'GET',
				url: `/mw/request/attributes/tree?${qs.stringify(body)}`,
			}),
			providesTags: [tags.request__attributes__tree],
		}),
		requestPresetSave: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/request/preset/save',
				body,
			}),
			invalidatesTags: [tags.request__preset__info, tags.request__presets],
		}),
		requestPresetInfo: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/request/preset/info?${qs.stringify(body)}`,
			}),
			providesTags: [tags.request__preset__info],
		}),
		requestPresetInfoQuery: builder.query({
			query: (body) => ({
				method: 'GET',
				url: `/mw/request/preset/info?${qs.stringify(body)}`,
			}),
			providesTags: [tags.request__preset__info],
		}),
		requestFilterDelete: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/request/filter/delete',
				body,
			}),
			invalidatesTags: [tags.request__preset__info, tags.request__presets],
		}),
		requestDocumentMake: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/request/document/make?${qs.stringify(body)}`,
			}),
			providesTags: [tags.request__document__make],
		}),
		requestDocumentGetDocument: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/request/document/getDocument?${qs.stringify(body)}`,
			}),
			providesTags: [tags.request__document__getDocument],
		}),
		requestAttributesExtended: builder.query({
			query: (body) => ({
				method: 'GET',
				url: `/mw/request/attributesExtended?${qs.stringify(body)}`,
			}),
			providesTags: [tags.request__attributesExtended],
		}),
	}),
});

export const {
	requestAttributesDict,
	requestPresets,
	requestFilter,
	requestFilterApply,
	requestPresetApply,
	requestFilterApplyCsvOneStep,
	requestFilterApplyCsvexport,
	requestFilterApplyXlsxexport,
	requestAttributes,
	requestAttributesTree,
	requestPresetSave,
	requestPresetInfo,
	requestPresetInfoQuery,
	requestFilterDelete,
	requestDocumentMake,
	requestDocumentGetDocument,
	requestAttributesExtended,
} = requestApi.endpoints;

export default requestApi;
